/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type BatchAutocompleteItemSchemaField = typeof BatchAutocompleteItemSchemaField[keyof typeof BatchAutocompleteItemSchemaField];


export const BatchAutocompleteItemSchemaField = {
  skills: 'skills',
  companies: 'companies',
  locations: 'locations',
  job_titles: 'job_titles',
  industries: 'industries',
  universities: 'universities',
  company_tags: 'company_tags',
  investors: 'investors',
  majors: 'majors',
  languages: 'languages',
  certification_names: 'certification_names',
  certification_vendors: 'certification_vendors',
  occupational_series: 'occupational_series',
} as const;
